import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router';
import PublicLayout from './pages/layout/PublicLayout';
import Recherche from './pages/Recherche';
import Login from './pages/Login';
import AuthProvider from './services/AuthProvider';
import Details from './pages/Details';
import RechercheAuto from './pages/RechercheAuto';
import PrivateLayout from './pages/layout/PrivateLayout';
import PdfTextExtractor from './pdf/PdfTextExtrator';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <AuthProvider>
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route index element={<App />} />
                </Route>

                <Route path="login" element={<Login />} />
                <Route element={<PrivateLayout />}>
                    <Route path='recherche' element={<Recherche />} />
                    <Route path='rechercheAuto/:type' element={<RechercheAuto />} />
                    <Route name="details" path="details/:type/:declaration" element={<Details />} />
                    <Route path='pieces' element={<PdfTextExtractor />} />
                </Route>
            </Routes>
        </AuthProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
